/**
 * Where to go after signing in. Only same-origin app paths are accepted, so a crafted
 * `?redirect=//evil.example` or `https://…` link cannot bounce the user off the app.
 */
export function safeRedirect(target: string | undefined | null, fallback = '/documents'): string {
  if (!target || !target.startsWith('/') || target.startsWith('//') || target.startsWith('/\\')) return fallback
  if (target === '/login' || target.startsWith('/login?') || target.startsWith('/login/')) return fallback
  return target
}
